export default "__VITE_ASSET__DM0gv_A8__"